<button
    *ngFor="let language of languagesList; index as i"
    class="header-nav nav-link nav-icon-text mx-5"
    (click)="changeLanguage(language.code)"
  >
    <img [src]="language.imgUrl" [alt]="language.name" />
    <span class="text-xs mt-1"> {{ language.shorthand }} </span>
</button>
